"use client"
import { X } from "react-feather"

const Alert = ({ children, type = "info", dismissible = false, onDismiss, className = "" }) => {
  const typeClasses = {
    info: "bg-blue-50 text-blue-800 border-blue-300",
    success: "bg-green-50 text-green-800 border-green-300",
    warning: "bg-yellow-50 text-yellow-800 border-yellow-300",
    error: "bg-red-50 text-red-800 border-red-300",
  }

  return (
    <div className={`p-4 mb-4 border rounded-lg ${typeClasses[type]} ${className}`} role="alert">
      <div className="flex items-center justify-between">
        <div className="flex-1">{children}</div>
        {dismissible && (
          <button
            type="button"
            className="ml-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8"
            onClick={onDismiss}
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  )
}

export default Alert
